export const PASSOS_ARIA_LABEL = "Etapas";
export const PASSO_REVISAO_LABEL = "Revisão";
